module.exports = __webpack_public_path__ + "static/media/fidweb-article-fight-scout-updates_optimized.64a386ab.png";